<template>
  <svg class="icon icon--chevron" width="23px" height="13px" viewBox="0 0 23 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g class="Arrow-Close" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g class="Arrow-Open" transform="translate(11.500000, 6.500000) rotate(-180.000000) translate(-11.500000, -6.500000) " fill="#666666" fill-rule="nonzero">
        <polygon class="back-button-copy-3" transform="translate(11.500000, 6.500000) rotate(-270.000000) translate(-11.500000, -6.500000) " points="5.60773737 6.04105293 5 6.64140971 5.60773737 7.2417665 16.498229 18 17.7137037 16.7992864 6.8232121 6.04105293 6.8232121 7.2417665 18 -3.79928643 16.7845253 -5"></polygon>
      </g>
    </g>
  </svg>
</template>

<script>
  export default{
    data(){
      return{}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/Chevron.vue